import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo } from "react";
const SyncContextShareContext = createContext({ syncContext: null });
export const SyncContextShareProvider = ({ children, syncContext }) => {
    const value = useMemo(() => ({ syncContext }), [syncContext]);
    return (_jsx(SyncContextShareContext.Provider, { value: value, children: children }));
};
export const useSyncContextShare = () => useContext(SyncContextShareContext);
export default SyncContextShareContext;
